import Vue from 'vue'
import validate from 'mixins/validate'

Vue.component('text-area', {
  props: {
    name: String,
    label: String,
    dynamicLabel: Function,
    type: {
      type: String,
      default: 'text'
    },
    modifier: {
      type: String,
      default: 'default'
    },
    autocapitalize: Boolean,
    initialValueGetter: Function,
    placeholder: String,
    info: String,
    error: String,
    required: Boolean,
    validateMethod: Function,
    maxlength: Number
  },
  data () {
    const data = {
      labelStr: '',
      dirty: false,
      isValid: false,
      isActive: false,
      isFocus: false,
      showLoading: false,
      showCharactersRemaining: false,
      errorMessage: this.error,
      showErrorMessage: false
    }
    if (this.dynamicLabel && typeof this.dynamicLabel === 'function') {
      data.labelStr = this.dynamicLabel(this.name)
    } else if (this.label) {
      data.labelStr = this.label
    } else if (this.placeholder) {
      data.labelStr = this.placeholder
    }
    if (this.initialValueGetter && this.initialValueGetter.bind !== 'undefined') {
      data.inputValue = this.initialValueGetter(this.name)
    } else {
      data.inputValue = ''
    }
    if (this.maxlength) {
      data.showCharactersRemaining = true
      data.charactersRemaining = this.maxlength - data.inputValue.length
    }
    return data
  },
  watch: {
    inputValue () {
      if (!this.dirty) this.dirty = true

      this.validateInput()

      this.$emit('change', {
        value: this.inputValue,
        name: this.name
      })
    }
  },
  mounted () {
    this.$emit('change', {
      value: this.inputValue,
      name: this.name
    })
    if (this.inputValue) {
      this.isActive = true
      this.isFocus = true
      this.unsetActive()
    }
  },
  methods: {
    validateInput () {
      if (this.validateMethod) {
        const response = this.validateMethod({
          value: this.inputValue,
          name: this.name
        })
        this.isValid = response.valid
      } else if (this.required && !this.inputValue) {
        this.isValid = false
      } else {
        this.isValid = true
      }
      return this.isValid
    },
    setActive () {
      this.isActive = true
      this.isFocus = true
      this.validateInput()
    },
    unsetActive () {
      this.isFocus = false
      this.validateInput()
    },
    getDynamicClasses () {
      const classes = []
      if (this.isFocus) {
        classes.push('is-focus')
        classes.push('is-active')
      } else {
        if (this.inputValue) {
          classes.push('is-active')
          if (this.isValid) {
            classes.push('text-input--champagne')
          } else {
            classes.push('form-row__error is-error')
          }
        }
      }
      return classes.join(' ')
    },
    refresh () {
      setTimeout(() => {
        this.inputValue = this.$refs.input.value
        if (this.inputValue) this.setActive()
      }, 0)
    }
  },
  mixins: [validate],
  template: `
  <div
    class="text-input text-input--text-area"
    :class="[ 'text-input--'+modifier, (!isValid && dirty)?'form-row__error': '' ]">
    <div class="text-area-input__wrapper">
      <label
      class="text-input__label"
      :for="name"
      >{{labelStr}}</label>
      <div
        class="text-input__info"
        v-if="info">
        <div class="info-icon">
          <svg  class="w1" viewBox="0 0 24 24">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-tooltip" x="0" y="0"></use>
          </svg>
        </div>
        <div class="info-text">{{(info)}}</div>
      </div>
      <textarea
        class="text-input__el text-input__text-area p1"
        :class="{ 'has-errors' : !isValid }"
        :name="name"
        :id="name"
        :maxlength="maxlength"
        :placeholder="placeholder"
        v-model="inputValue"
        v-on:focus="setActive"
        v-on:blur="unsetActive"
        @blur="$emit('value-change')" >
      </textarea>
      <div class="loading-icon" v-if="showLoading"><div class="img__loader"></div></div>
    </div>
    <p class="text-input text-input__remaining-characters" v-if="showCharactersRemaining">{{charactersRemaining}}/{{maxlength}}</p>
    <transition name="fade">
      <p v-if="dirty && !isValid" class="form-row__error__text-error text-error">{{errorMessage}}</p>
    </transition>
  </div>`
})
